import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Input as AntInput } from "antd";
import classNames from "classnames";
import "./Input.scss";
import { Icon } from "../../particles/Icon";
import { styleClasses } from "../../helpers";
import { Text } from "../../particles/Text";
const CSS_PREFIX = `lav-components-input`;
export const Input = (_a) => {
    var { className = "", errorText, placeholder, size, state } = _a, antProps = __rest(_a, ["className", "errorText", "placeholder", "size", "state"]);
    return (_jsxs("div", { className: `${CSS_PREFIX}-container`, children: [_jsx(AntInput, Object.assign({ className: classNames(styleClasses(CSS_PREFIX, { state, size }), {
                    [className]: !!className,
                }), disabled: state === "disabled", status: state === "error" ? "error" : undefined, placeholder: placeholder }, antProps)), state === "error" && errorText && (_jsxs("div", { className: `${CSS_PREFIX}-error-text`, children: [_jsx(Icon, { variant: "IconBan", size: "mini" }), _jsx(Text, { size: "body1", children: errorText })] }))] }));
};
